import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Divider from 'components/Divider'
import { Form, Text, TextArea, Select, Checkbox, ColorPicker, WeekdayPicker, DateTimePicker, Number } from 'components/forms'
import Button from 'components/Button'
import ToggledContentWrapper from 'components/ToggledContentWrapper'
import CategoryGrid, { GridSelector } from 'components/CategoryGrid'
import listTags from 'gql/query/listTags'
import { ContentBlock } from 'components/ContentBlock'
import { notEmpty } from 'helpers/validators'
import TagEditor from 'components/TagEditor'
import { loadAppConstants, listShops } from 'gql/query'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const Category = ({ appData, data, formData, onChangeMultiEdit, apiRef, ConfirmButton, ConfirmModal, newRecord, mutations: { createItem, updateItem }, multiEdit }) => {
	const [t, i18n] = useTranslation()
	const categoryForm = (
		<Form
			smartSubmit={(!newRecord && !multiEdit?.isActive)}
			apiRef={apiRef}
			onChange={(e) => multiEdit?.isActive && onChangeMultiEdit(e, formData)}
			onSubmit={newRecord ? createItem : updateItem}
			initialValues={formData}
			render={({ formState }) => (
				<Fragment>
					<Row>
						<Col xs>
							<div>
								<Number
									field='position'
									label={t('category_section.fields.position')}
									inline
									disabled={multiEdit?.isActive}
									placeholder={t('category_section.placeholders.position')}
									withControls={false}
									{...notEmpty()}
									validateOnChange
								/>
								<Checkbox inline field='isActive' label={t('common.fields.isActive')}/>
								{ConfirmModal()}
							</div>
							<Text
								field='name'
								disabled={multiEdit?.isActive}
								label={t('common.fields.name')}
								placeholder='Bezeichnung eintragen'
								{...notEmpty()}
								validateOnChange />
							<Select
								inline
								style={{ width: '260px' }}
								field='tagId'
								label={t('category_section.fields.group_tag')}
								valueField='id'
								labelField='name'
								isClearable
								remoteOptions={{
									query: listTags,
									variables: { type: 'CategoryTag' }
								}}
							/>
							<TagEditor tagType='CategoryTag'/>
						</Col>
						<Col xs>
							<DateTimePicker
								minDate={moment().utc()}
								picker='date'
								field='validAfter'
								label={t('category_section.fields.valid_after')}/>
							<WeekdayPicker
								field='weekDays'
								label={t('common.fields.week_days')}
								placeholder={t('common.placeholders.week_days')}/>
							{appData.isShopFieldActive &&
								<Select
									label={t('common.fields.shop_affiliation')}
									field='shopId'
									valueField='id'
									labelField='name'
									validate={val => !val && appData.shopAccess ? t('validators.required') : null}
									remoteOptions={{
										query: listShops,
										modifyOptions: (options => {
											return options
												.map(opt => opt.codePrefix ? ({ ...opt, name: `${opt.name} - "${opt.codePrefix}"` }) : opt)
										})
									}}
									isClearable={!appData.shopAccess}
								/>
							}
						</Col>
						<Col xs>
							<p className='form-group-label'>{t('category_section.strings.availability')}</p>
							<Checkbox field='isForMobileWaiter' label={t('category_section.fields.for_mobile_waiter')}/>
							<Checkbox field='isLearningMode' label={t('category_section.fields.for_learning_mode')}/>
							<Checkbox field='pluMode' label={t('category_section.fields.plu_mode')}/>
						</Col>
					</Row>
					<Divider visible/>
					<Row>
						<Col xs>
							<GridSelector
								field='dimensions'
								label={t('category_section.fields.grid_dimensions')}
								immidiateSubmit
							/>
							<ColorPicker
								field='color'
								label={t('category_section.fields.color')}
								immidiateSubmit
							/>
						</Col>
						<Col xs>
							<Select
								label={t('category_section.fields.sort_type')}
								field='sortId'
								immidiateSubmit
								remoteOptions={{
									query: loadAppConstants,
									variables: { type: 43, language: i18n.language }
								}}
							/>
						</Col>
						<Col xs>
							<label>
								<TextArea
									field='description'
									label={t('category_section.fields.description')}
									placeholder={t('category_section.placeholders.description')}
								/>
							</label>
						</Col>
					</Row>
					{ConfirmButton(formState)}
					{newRecord &&
					<Fragment>
						<Divider height={20}/>
						<Col type='row'>
							<Button type='submit' status='primary' text={t('common.buttons.create')}/>
						</Col>
					</Fragment>
					}
				</Fragment>
			)}
		/>
	)
	return (newRecord ?
		<ContentBlock>{categoryForm}</ContentBlock> :
		<Fragment>
			<ToggledContentWrapper expanded label={t('category_section.strings.open_settings')}>
				{categoryForm}
			</ToggledContentWrapper>
			<ContentBlock topBorder>
				<CategoryGrid
					readOnly={data.sortId !== '2'}
					category={data}
				/>
			</ContentBlock>
		</Fragment>
	)
}

export default Category
